// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/destructuring-assignment */

import React from 'react'
import { Text, Button as GrommetButton } from '@usap/uicomponents'

interface IButtonProps {
  label: string
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  styles?: any
  dataTestId?: string
  type?: 'button' | 'reset' | 'submit'
  disabled?: boolean
}

const buttonStyles = {
  border: '1px solid #D4D4D6',
  padding: '0 40px',
  borderRadius: '4px',
  background: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '40px',
}

const Button: React.FC<IButtonProps> = ({
  label, onClick, styles, dataTestId = 'button', type, disabled,
}) => (
  <GrommetButton
    plain
    data-testid={dataTestId}
    // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
    style={{ ...buttonStyles, ...styles }}
    onClick={onClick}
    type={type}
    disabled={disabled}
    label={(
      // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
      <Text color="dark-2" size="small" weight={600} style={{ letterSpacing: '0.1px', fontFamily: 'Roboto' }}>
        {label}
      </Text>
    )}
  />
)

export default React.memo(Button)
